import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
/**
 * Component with person status
 *
 * @component
 * @example
 * <select-person-status v-model="value"/>
 */

export default defineComponent({
  name: "SelectPersonStatus",
  setup: function setup() {
    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t,
        te = _useI18n.te;

    var statuses = computed(function () {
      var statusesAll = [{
        value: "1",
        label: t("select.person-status.mr")
      }, {
        value: "2",
        label: t("select.person-status.mrs")
      }, {
        value: "3",
        label: t("select.person-status.dr")
      }, {
        value: "5",
        label: t("select.person-status.prof")
      }];

      if (te("select.person-status.ms")) {
        statusesAll.push({
          value: "4",
          label: t("select.person-status.ms")
        });
      }

      return statusesAll;
    });
    return {
      statuses: statuses
    };
  }
});